import template from './recapResponsePage.html';
import controller from './recapResponsePage.controller';

let pageComponent = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    // page: '<',
    // recapResponse: '<',
    pageResponse: '<',
    showExitButton: '<',
    showCheckoutClaimsAfterRecap: '<',
    isSaving: '<',
    isSavingPartial: '<',
    onSavePartialResponse: '&',
    onFinish: '&',
    onExit: '&',
  }
};

export default pageComponent;
